import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import SliderPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/SliderPicklistControl';
import BigPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/BigPicklistControl';

const hiddenFieldNames = ['adjustedTotal', 'target', 'adjustedAverageExpense'];

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(name => hiddenFieldNames.includes(name), {
    hidden: true,
  })
  .nameOverride('adjustment', {
    _component: () => SliderPicklistControl,
  })
  .typeOverride('multipicklist', {
    _component: () => BigPicklistControl,
    _customProps: {
      multiple: true,
    },
  });
